/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_TitleInputs */

const en_pc_tut_title = /** @type {(inputs: Pc_Tut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use PdfCraft`)
};

const zh_pc_tut_title = /** @type {(inputs: Pc_Tut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何使用 PdfCraft`)
};

/**
* | output |
* | --- |
* | "How to use PdfCraft" |
*
* @param {Pc_Tut_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_title = /** @type {((inputs?: Pc_Tut_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_title(inputs)
	return zh_pc_tut_title(inputs)
});
export { pc_tut_title as "pc.tut.title" }